import { render } from "./servicesItem2.vue?vue&type=template&id=589c3e7e"
import script from "./servicesItem2.vue?vue&type=script&lang=js"
export * from "./servicesItem2.vue?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src719114813/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__